import * as css from './ReportLine.css';

function ReportLine({title, value, icon, color=''}) {
    
    return <css.item>
        <css.rightPart icon={icon}>{title}</css.rightPart>
        <css.leftPart color={color}>{value}</css.leftPart>
    </css.item>;
}
export default ReportLine;